
import { defineComponent, PropType } from 'vue'
import { Check, Run, ScaCheck } from '~/types/types'
import { gateStatusIcon } from '~/utils/ui'
import { resolveNodes } from '~/utils/array'

export default defineComponent({
  name: 'ReportCardView',
  props: {
    run: {
      type: Object as PropType<Run>,
      required: true
    }
  },
  computed: {
    checks(): Check[] {
      return resolveNodes(this.run.checks) ?? []
    },
    scaChecks(): ScaCheck[] {
      return resolveNodes(this.run.scaChecks) ?? []
    },
    provider(): string {
      return this.$route.params.provider
    },
    badgeIcon(): string {
      return gateStatusIcon(this.run.status)
    }
  }
})
